import { render, staticRenderFns } from "./proReview.vue?vue&type=template&id=5fc6addb&scoped=true&"
import script from "./proReview.vue?vue&type=script&lang=js&"
export * from "./proReview.vue?vue&type=script&lang=js&"
import style0 from "./proReview.vue?vue&type=style&index=0&id=5fc6addb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc6addb",
  null
  
)

export default component.exports